import {Repository, createRepository} from '@/repositories/Base/Repository'

class OrderRepository extends Repository {
    endpoint = 'integration'

    sendOrder(params) {
        return this.$axios.post(`${this.endpoint}/order`, params)
    }

    sendReport(params) {
        return this.$axios.post(`${this.endpoint}/report`, params)
    }

    editRecipientReport(params) {
        return this.$axios.post(`${this.endpoint}/editRecipientReport`, params)
    }

    rePrint(params) {
        return this.$axios.post(`${this.endpoint}/resend/printer`, params)
    }

    getSupportObservations(params) {
        return this.$axios.post(`${this.endpoint}/getSupportObservations`, params)
    }
}

export default new OrderRepository()

export const create = createRepository(OrderRepository)